import { DocumentTextIcon } from '@heroicons/react/outline';
import React from 'react';

const EmptyReport = () => {
  return (
    <button
      type="button"
      className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 
      p-12 text-center hover:border-gray-400 focus:outline-none focus:ring-2 
      focus:ring-indigo-500 focus:ring-offset-2
      center mx-auto"
    >
      <DocumentTextIcon
        className="-ml-0.5 mr-2 h-8 w-8 text-gray-500 center mx-auto"
        aria-hidden="true"
      />
      <span className="mt-2 block text-sm font-semibold text-gray-900">
        No Report active Filter
      </span>
    </button>
  );
};

export default EmptyReport;
